import { Stack } from '@mui/material';

import { useAccountTicketsOverview } from 'restful/accounts';

import DownloadApp from 'components/@account/DownloadApp';
import UpcomingEvents from 'components/@account/UpcomingEvents';
import { isEventToday } from 'components/@events/utils';
import FavoritesStack from 'components/@favorites/FavoritesStack';

import LoyaltyCards from './LoyaltyCards';
import NameCard from './NameCard';

const AuthenticatedSection = () => {
  const { upcomingEvents: events, isLoading } = useAccountTicketsOverview();

  const upcomingEvents = events
    .sort((a, b) => (isEventToday(a) && !isEventToday(b) ? -1 : 1))
    // In account we want to show all events that are happening today, if we don't have any just show the first upcoming one
    .filter((event, index) => isEventToday(event) || index === 0);

  return (
    <>
      <NameCard />
      <FavoritesStack />
      <Stack>
        <LoyaltyCards />
        <UpcomingEvents
          events={upcomingEvents}
          isLoading={isLoading}
          isAccountOverview
        />
        <DownloadApp
          sx={{
            display: { xs: 'block', md: 'none' },
            mt: 1,
          }}
        />
      </Stack>
    </>
  );
};

export default AuthenticatedSection;
